export default __webpack_public_path__ + "static/media/744.0de6b479.png";